import { render, staticRenderFns } from "./modal-history.vue?vue&type=template&id=38359d98&"
import script from "./modal-history.vue?vue&type=script&lang=js&"
export * from "./modal-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports